// @flow

import React, { useState } from 'react';
import type { Element } from 'react';

import { createPortal } from 'react-dom';

import { faTimes } from '@fortawesome/free-solid-svg-icons';

import type { DialogProps, DialogStateProps, HeaderProps } from './types';

import {
  StyledDialogHeader,
  StyledDialogContent,
  StyledDialogSecondaryContent,
  StyledDialogFooter,
  StyledDialog,
  StyledOverlay,
  StyledHeaderContent,
  StyledHeaderCloseButton,
  StyledDualContentWrapper
} from './styles';

const DialogState = ({ children }: DialogStateProps): Element<any> => {
  const [open, setOpen] = useState(false);

  return children(open, setOpen);
};

const Dialog = ({
  children,
  enableGrid,
  size = 'MEDIUM',
  onDocumentClick = () => {}
}: DialogProps): any => {
  if (document && document.body) {
    return createPortal(
      <StyledOverlay onClick={onDocumentClick}>
        <StyledDialog size={size} enableGrid={enableGrid}>
          {children}
        </StyledDialog>
      </StyledOverlay>,
      document.body
    );
  }

  return null;
};

const DialogHeader = ({
  children,
  onClose,
  renderCloseButton,
  renderHeaderContent,
  ...props
}: HeaderProps) => (
  <StyledDialogHeader {...props}>
    {renderCloseButton || <StyledHeaderCloseButton icon={faTimes} onClick={onClose} />}
    {renderHeaderContent || <StyledHeaderContent>{children}</StyledHeaderContent>}
  </StyledDialogHeader>
);

Dialog.DialogState = DialogState;
Dialog.DialogHeader = DialogHeader;
Dialog.DialogContent = StyledDialogContent;
Dialog.DialogSecondaryContent = StyledDialogSecondaryContent;
Dialog.DialogFooter = StyledDialogFooter;
Dialog.DialogDualContentWrapper = StyledDualContentWrapper;

export default Dialog;
